export default __webpack_public_path__ + "static/media/bg.bd676bf5.jpg";